(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/fullscreen-widget.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/fullscreen-widget.js');

'use strict';

const WidgetAreaFullscreen = svs.components.onboarding.widgetAreaFullscreen.WidgetAreaFullscreen;
const useFullscreenWidget = svs.eurojackpot.react.context.useFullscreenWidget;
const FullscreenWidget = () => {
  const _useFullscreenWidget = useFullscreenWidget(),
    showFullscreen = _useFullscreenWidget.showFullscreen,
    closeFullscreen = _useFullscreenWidget.closeFullscreen;
  React.useEffect(() => {
    if (showFullscreen) {
      document.body.style.overflowY = 'hidden';
      const timeoutElement = setTimeout(() => {
        const divNode = Object.assign(document.createElement('div'), {
          className: 'mutation-observer-trigger-node'
        });
        document.body.appendChild(divNode);
      }, 50);
      const handleEscKey = event => {
        if (event.key === 'Escape') {
          closeFullscreen();
        }
      };
      document.addEventListener('keydown', handleEscKey);
      return () => {
        clearTimeout(timeoutElement);
        document.removeEventListener('keydown', handleEscKey);
        const node = document.querySelector('.mutation-observer-trigger-node');
        if (node) {
          document.body.removeChild(node);
        }
      };
    }
    document.body.style.overflowY = 'unset';
  }, [showFullscreen, closeFullscreen]);
  if (!showFullscreen) {
    return null;
  }
  return ReactDOM.createPortal(React.createElement("div", {
    className: "ej-startpage-fullscreen-container"
  }, React.createElement(WidgetAreaFullscreen, {
    areaName: "eurojackpotFullscreenWidgetArea",
    branding: "eurojackpot",
    onCloseFullscreen: closeFullscreen,
    widgetAreaName: "eurojackpotFullscreenWidgetArea"
  })), document.getElementById('main-content'));
};
setGlobal('svs.eurojackpot.react.components', {
  FullscreenWidget
});

 })(window);